/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProgressRing from './ProgressRing.vue';
const __vue_script__ = {
	name: 'FilePreview',
	props: ['file'],
	components: {
		ProgressRing
	},
	data() {
		return {
			src: null,
			optimize: this.file.optimize
		}
	},
	mounted() {
		if (this.is_image) {
			if (window.FileReader) {
				let fr = new FileReader();
				fr.onload = () => this.src = fr.result;
				fr.readAsDataURL(this.file.file_obj);
			}
		}
	},
	filters: {
		file_size(value) {
			return neo.form.formatters.FileSize(value);
		},
		file_name(value) {
			return value;
			// return neo.utils.file_name_ellipsis(value, 9);
		}
	},
	computed: {
		private_icon() {
			return neo.utils.icon(this.is_private ? 'lock' : 'unlock');
		},
		is_private() {
			return this.file.doc ? this.file.doc.is_private : this.file.private;
		},
		uploaded() {
			return this.file.request_succeeded;
		},
		is_image() {
			return this.file.file_obj.type.startsWith('image');
		},
		is_optimizable() {
			let is_svg = this.file.file_obj.type == 'image/svg+xml';
			return this.is_image && !is_svg && !this.uploaded && !this.file.failed;
		},
		is_cropable() {
			let croppable_types = ['image/jpeg', 'image/png'];
			return !this.uploaded && !this.file.uploading && !this.file.failed && croppable_types.includes(this.file.file_obj.type);
		},
		progress() {
			let value = Math.round((this.file.progress * 100) / this.file.total);
			if (isNaN(value)) {
				value = 0;
			}
			return value;
		}
	}
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-preview"},[_c('div',{staticClass:"file-icon"},[(_vm.is_image)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.file.name}}):_c('div',{staticClass:"fallback",domProps:{"innerHTML":_vm._s(_vm.neo.utils.icon('file', 'md'))}})]),_vm._v(" "),_c('div',[_c('div',[(_vm.file.doc)?_c('a',{staticClass:"flex",attrs:{"href":_vm.file.doc.file_url,"target":"_blank"}},[_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(_vm._f("file_name")(_vm.file.name)))]),_vm._v(" "),_c('div',{staticClass:"ml-2",domProps:{"innerHTML":_vm._s(_vm.private_icon)}})]):_c('span',{staticClass:"flex"},[_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(_vm._f("file_name")(_vm.file.name)))]),_vm._v(" "),_c('button',{staticClass:"ml-2 btn-reset",attrs:{"title":('Toggle Public/Private')},on:{"click":function($event){return _vm.$emit('toggle_private')}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.private_icon)}})])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"file-size"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm._f("file_size")(_vm.file.file_obj.size))+"\n\t\t\t")])]),_vm._v(" "),(_vm.is_optimizable)?_c('label',{staticClass:"optimize-checkbox"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.optimize},on:{"change":function($event){return _vm.$emit('toggle_optimize')}}}),_vm._v("Optimize")]):_vm._e(),_vm._v(" "),_c('div',[(_vm.file.error_message)?_c('span',{staticClass:"file-error text-danger"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.file.error_message)+"\n\t\t\t")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"file-actions"},[_c('ProgressRing',{directives:[{name:"show",rawName:"v-show",value:(_vm.file.uploading && !_vm.uploaded && !_vm.file.failed),expression:"file.uploading && !uploaded && !file.failed"}],attrs:{"primary":"var(--primary-color)","secondary":"var(--gray-200)","radius":24,"progress":_vm.progress,"stroke":3}}),_vm._v(" "),(_vm.uploaded)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.neo.utils.icon('solid-success', 'lg'))}}):_vm._e(),_vm._v(" "),(_vm.file.failed)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.neo.utils.icon('solid-error', 'lg'))}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"file-action-buttons"},[(_vm.is_cropable)?_c('button',{staticClass:"btn btn-crop muted",domProps:{"innerHTML":_vm._s(_vm.neo.utils.icon('crop', 'md'))},on:{"click":function($event){return _vm.$emit('toggle_image_cropper')}}}):_vm._e(),_vm._v(" "),(!_vm.uploaded && !_vm.file.uploading && !_vm.file.failed)?_c('button',{staticClass:"btn muted",domProps:{"innerHTML":_vm._s(_vm.neo.utils.icon('delete', 'md'))},on:{"click":function($event){return _vm.$emit('remove')}}}):_vm._e()])],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2f77e208_0", { source: ".file-preview{display:flex;align-items:center;padding:.75rem;border:1px solid transparent}.file-preview+.file-preview{border-top-color:var(--border-color)}.file-preview:hover{background-color:var(--bg-color);border-color:var(--dark-border-color);border-radius:var(--border-radius)}.file-preview:hover+.file-preview{border-top-color:transparent}.file-icon{border-radius:var(--border-radius);width:2.625rem;height:2.625rem;overflow:hidden;margin-right:var(--margin-md);flex-shrink:0}.file-icon img{width:100%;height:100%;object-fit:cover}.file-icon .fallback{width:100%;height:100%;display:flex;align-items:center;justify-content:center;border:1px solid var(--border-color);border-radius:var(--border-radius)}.file-name{font-size:var(--text-base);font-weight:var(--text-bold);color:var(--text-color);display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}.file-size{font-size:var(--text-sm);color:var(--text-light)}.file-actions{width:3rem;flex-shrink:0;margin-left:auto;text-align:center}.file-actions .btn{padding:var(--padding-xs);box-shadow:none}.file-action-buttons{display:flex;justify-content:flex-end}.muted{opacity:.5;transition:.3s}.muted:hover{opacity:1}.optimize-checkbox{font-size:var(--text-sm);color:var(--text-light);display:flex;align-items:center;padding-top:.25rem}.file-error{font-size:var(--text-sm);font-weight:var(--text-bold)}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__